import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useNavigate } from 'libs/router'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'libs/query'
import { routes } from 'config/routes'
import type { AreaPayload } from 'features/areas/types/areas.types'

export const useAddAreaMutation = () => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const navigate = useNavigate()

	const { mutate: addAreaMutation, isPending: isAddAreaLoading } = useMutation({
		// TODO: use apiRoutes
		mutationFn: (data: AreaPayload) => axiosPrivate.post('/booths/', data),
		onSuccess: () => {
			useToast({ type: 'success', message: t('Area created') })()
			navigate(routes.areaIndex)
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		addAreaMutation,
		isAddAreaLoading
	}
}
